export enum ActionTypes {
  DO_LOGIN = '@user/DO_LOGIN',
  DO_LOGOUT = '@user/DO_LOGOUT',
}

export interface IAction {
  type: ActionTypes,
  payload?: any,
}
